import { render, staticRenderFns } from "./ProjectScope.vue?vue&type=template&id=47f750b5&scoped=true&"
import script from "./ProjectScope.vue?vue&type=script&lang=js&"
export * from "./ProjectScope.vue?vue&type=script&lang=js&"
import style0 from "./ProjectScope.vue?vue&type=style&index=0&id=47f750b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f750b5",
  null
  
)

export default component.exports